
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';

import usericon from "../assets/images/user.png"

const testimonials = [
  {
     description:"BIOME  mixes calm nature with easy access to KIA and Laurus Labs. I like the vision of walking trails with no cars. It is the perfect plot for my green dream home, good choice.",
     name:"Rajesh K",
     job:"Bengaluru Tech Professional"
  },
   {
     description:"Close to Krishnadevaraya history and Puttaparthi, with real farms and trees. Great for family time. We pre booked a plot simple and sustainable living.",
     name:"Priya M",
     job:"Hyderabad Family"
  },
   {
     description:"It's close to factories but still a proper farm retreat with solid sustainability. Pre booked my villa for retirement history and future in one spot. Excited!",
     name:"Vikram P",
     job:"Chennai Retiree"
  },
   {
     description:"Love the agroforestry setup so close to Bangalore good for food and eco stuff. I pre booked my spot. I love the amenities Biome provides which balances nature and real life perfectly.",
      name:"Arun S",
     job:"Mumbai"
  },

        {
	  description:"As a doctor, I spend my days inside sterile environments. Biome Farms gave me something I didn’t realize I was missing space to breathe, to slow down. The design isn’t just aesthetic, it’s therapeutic. Every visit feels like a reset for name:my mind and body.",
     name:"DR prasad", 
	  job:"Senior gastro surgeon yashodha hospitals, hyderabad"
	  },
	   
	    {
	 description:"I’ve spent years talking about work-life balance to others, but Biome is where I finally experienced it myself. It’s not just a home, it’s a shift in how you live. The calm, the community, the way spaces flow everything feels intentional.",
	 name:"Neha",  
	 job:"HRBP , IDFC first Bank"
      
	   },
	    {
	 description:"Initially, I evaluated Biome as an investment. But the moment I experienced the space, it became personal. It’s rare to find something that delivers both emotional value and long-term appreciation so seamlessly.",
	 name:"NAVEE",
	  job:"Centre head at HSBC "
	  },
	   {
	 description:"I’ve seen many real estate projects, but Biome stands apart. It’s not just built, it's thought through. The design respects nature, and the experience respects people. It’s the kind of place you feel proud to be part of.",
	  name:"Anith redd",
	  job:"MD, TONIQUE "
	  },
	   {
	 description:"What surprised me most was the sense of belonging. It’s rare today. Biome isn’t crowded, yet it never feels empty. There’s a quiet community energy that makes you feel at home instantly.",
	  name:"Harinat",
	  job:"HARVIS INFRA "
	  },
	   {
	 description:"Luxury today is space, silence, and meaning. Biome understands that deeply. It’s not about excess, it's about experience. And that’s exactly what it delivers.",
	 name:"Madhavi Harish",
	 job:"Md Times Reality"
	  },
	   {
	 description:"There’s a certain poetry in how Biome is designed. Mornings feel softer, evenings feel longer. It changes your rhythm without you even noticing. That’s rare, and that’s powerful.", 
	 name:"Narsimhap",
	 job:"Ex-Banker"
	   },
	   {
	 description:"My work is intense and mentally consuming. Biome Farms has become my sanctuary, a place where I can disconnect without feeling disconnected from life. It's a subtle luxury, not loud and that’s what makes it powerful.",
	 name:"Dinesh Hegd",
	 job:"Senior Attorney "
},
]




const Testimonials = () => {
  return (
      <div class="biome biome-912 biome-testimonial-912 ">

  <div className="biome-element biome-element-0d573b2 e-flex e-con-boxed e-con e-parent e-lazyloaded">
    <div className="e-con-inner section-scroll-animation">
      <div class="elementor-widget-container">
        <div class="ekit-wid-con">
          <div
            class="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-">
            <h1 class="ekit-heading--title elementskit-section-title attr-text-white">
              <span><span>Testimonials</span></span></h1>
          </div>
        </div>
      </div>
      <div className="biome-element biome-element-74a66d e-grid e-con-full e-con e-child">
        <Swiper loop={true} autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }} allowTouchMove={true} modules={[Autoplay, Navigation]} spaceBetween={24} slidesPerView={3}
          breakpoints={{
                    0: {
                    slidesPerView: 1,   
                    spaceBetween: 12,
                    },
                    760: {
                    slidesPerView: 1, 
                    spaceBetween: 0,
                    },
                    1024: {
                    slidesPerView: 3,  
                    spaceBetween: 24,
                    },
                }}>
          {testimonials.map((testimonial, index) =>
          <SwiperSlide>
            <div
              className="biome-element biome-element-3892598 biome-widget biome-widget-testimonial animated fadeInUp">
              <div className="biome-widget-container">
                <div className="biome-testimonial-wrapper">
                  <p className="biome-testimonial-content">
                    {testimonial.description}
                  </p>

                  <div className="biome-testimonial-meta biome-has-image biome-testimonial-image-position-aside">
                    <div className="biome-testimonial-meta-inner">
                      <div className="biome-testimonial-image">
                        <img decoding="async" width="300" height="300" src={usericon} alt=""
                          sizes="(max-width: 300px) 100vw, 300px" />
                      </div>

                      <div className="biome-testimonial-details">
                        <div className="biome-testimonial-name">{testimonial.name}</div>
                        <div className="biome-testimonial-job">{testimonial.job}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          )}
        </Swiper>
      </div>
    </div>
  </div>
</div>
  );
};

export default Testimonials;


